import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect, useMemo } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Eventosall() {
    const { csrfToken } = useCsrfToken();
    const [eventos, setEventos] = useState([]);
    const [tags, setTags] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Eventos',
                name: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
                tags: item.tags,
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/event`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setEventos(transformData(data));
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                });
            fetch(`${API_URL}/api/filtertags`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setTags(data))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, csrfToken]);

    const [selectedTag, setSelectedTag] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const handleTagChange = (event) => {
        setSelectedTag(event.target.value);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredServices = useMemo(() => {
        return eventos.filter(item => {
            const matchesTag = selectedTag ? item.tags.some(tg => tg.pivot.tag_id === parseInt(selectedTag)) : true;

            const normalizedName = removeAccents(item.name.toLowerCase());
            const normalizedDesc = removeAccents(item.desc.toLowerCase());
            const normalizedSearch = removeAccents(searchTerm.toLowerCase());

            const matchesSearchTerm = normalizedName.includes(normalizedSearch) || normalizedDesc.includes(normalizedSearch);

            return matchesTag && matchesSearchTerm;
        });
    }, [eventos, selectedTag, searchTerm]);

    return (
        <>
            <div className="row justify-content-center bg-inverted py-2">
                <div className="col-12 col-md-3">
                    <select name="specialties" className='form-control' onChange={handleTagChange}>
                        <option value="">Filtrar por área o especialidad</option>
                        <option value="">-Todo-</option>
                        {tags.map((tg, index) => (
                            <option key={index} value={tg.id}>{tg.title}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-3">
                    <input name="searchfield" type="text" className='form-control' placeholder='Buscar...' onChange={handleSearchChange} />
                </div>
            </div>
            <div className="row">
                {filteredServices.length > 0 ? (
                    filteredServices.map((item, index) => {
                        const stripTags = (html) => {
                            let doc = new DOMParser().parseFromString(html, 'text/html');
                            return doc.body.textContent || "";
                        };
                        return (
                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="listing position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                    <div className="position-relative">
                                        <div className="listing-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                            <Link to={`/evento/${item.slug}`}>
                                                <img src={item.image} className="img-fluid" alt="" />
                                            </Link>
                                        </div>

                                        <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                            <Link to="#" className="badge text-light bg-dark">{item.tag}</Link>
                                        </div>
                                    </div>

                                    <div className="pt-4 flex-grow-1 d-flex flex-column">
                                        <Link to={`/evento/${item.slug}`} className="text-dark title h5">{item.name}</Link>

                                        <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>

                                        <Link to={`/evento/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">Conocer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="col-12 mt-4 pt-2 text-center">
                        {isLoading ? (
                            <p className="text-muted">Cargando...</p>
                        ) : (
                            <p className="text-muted">Por el momento no hay eventos disponibles.</p>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
